var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew229({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.92,
    y: 3.16,
    width: 14.16,
    height: 9.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.35,8.91l-.59,1.77H2L3.92,5H4.8l1.92,5.64H6L5.34,8.91Zm1.84-.57L4.64,6.71c-.12-.36-.21-.7-.29-1h0c-.08.33-.17.67-.28,1L3.5,8.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.72,10.43a5.46,5.46,0,0,1-1.73.31A2.9,2.9,0,0,1,7.88,10a2.92,2.92,0,0,1-.78-2.1A2.82,2.82,0,0,1,10.15,5a3.4,3.4,0,0,1,1.4.26l-.17.6a2.83,2.83,0,0,0-1.25-.25A2.11,2.11,0,0,0,7.87,7.86,2.06,2.06,0,0,0,10,10.13,2.27,2.27,0,0,0,11,10V8.3H9.86V7.72h1.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.56,5v5.64h-.73V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew229);
export default __webpack_public_path__ + "static/media/Symbolpack_New_229.8d61dcb0a1ede36e86290a73a1e191cd.svg";
export { ForwardRef as ReactComponent };